export default "__VITE_ASSET__fe59d210__"